// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__pezOI","cardImage":"CardDetails_cardImage__KpSel","card":"CardDetails_card__cPjZj"};